import { render, staticRenderFns } from "./lower-editor.vue?vue&type=template&id=c1858216&scoped=true&"
import script from "./lower-editor.vue?vue&type=script&lang=js&"
export * from "./lower-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1858216",
  null
  
)

export default component.exports